
  import { css } from 'lit';
  export const styles = css`:host{--disabled-item-text-color: var(--ig-drop-down-disabled-item-text-color, var(--ig-gray-300));--border-color: var(--ig-drop-down-border-color, var(--ig-gray-100));--ig-theme-variant: dark}`;
  